(function() {
    'use strict';

    angular.module('app.clientes', []);
})();
